module.exports = __webpack_public_path__ + "img/certidao_ajuda.6d2018ce.jpg";